import React from 'react';
import PropTypes from 'prop-types';

// styles
import './styles.scss';

// components
import Card from '../../../cards/card/Card';

function SingleResult(props) {
  const { content: { data } } = props;
  const {
    cardType,
    image,
    recommendedCount,
    resourceType,
    slug,
    subtitle,
    tags,
    title,
  } = data[0];
  const dataContent = data[0];
  return (
    <li className="grid__item">
      { cardType === 'resource' ?
        <Card
          title={title}
          subtitle={subtitle}
          image={image}
          resourceType={cardType === 'resource' ? resourceType : ''}
          cardType={cardType}
          recommendedCount={recommendedCount}
          slug={`/${slug}`}
          tags={tags}
          {...dataContent}
        />
        :
        <Card
          title={title}
          subtitle={subtitle}
          image={image}
          cardType={cardType}
          recommendedCount={recommendedCount}
          slug={`/${slug}`}
          tags={tags}
          {...dataContent}
        />
      }
    </li>
  );
}

SingleResult.propTypes = {
  content: PropTypes.object.isRequired,
};

SingleResult.contextTypes = {
  t: PropTypes.func,
};

export default SingleResult;



// WEBPACK FOOTER //
// ./src/app/components/pages/search/results/SingleResult.js